module.exports = __webpack_public_path__ + "static/media/7d_website_logo_Gold_newtech.abd87972.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/7d_website_logo_Gold_newtech.jpg
// module id = 112
// module chunks = 0